import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import CustomModal from "../../shared/CustomModal";

const TemplateCard = ({ url, name }) => {
  const [templateModal, setTemplateModal] = useState(false);

  return (
    <div className="a4-tile" onClick={() => setTemplateModal((prev) => !prev)}>
      <iframe className="a4-iframe" src={url} sandbox="allow-same-origin" />
      <p className="template-name">{name}</p>
      <div className="eye-hover">
        <FontAwesomeIcon size="2xl" color="white" icon={faEye} />
      </div>

      <CustomModal
        className={"a4-template-modal"}
        modalHeader={name}
        toggle={() => setTemplateModal((prev) => !prev)}
        isOpen={templateModal}
        children={
          <div className="a4-tile template-a4">
            <iframe
              className="a4-iframe template-a4-iframe"
              src={url}
              sandbox="allow-same-origin"
            />
          </div>
        }
      />
    </div>
  );
};

export default TemplateCard;
